module.exports = __webpack_public_path__ + "media/images/countrysquared/st-bf5924bfd01c3ab9f18cf8cffdc2b967.svg";